import React, { PropsWithChildren } from "react";

import { css, cx } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { CenteredLoader } from "@/uiKit/atoms/Loader.tsx";
import { SuspenseWithError } from "@/uiKit/atoms/SuspenseWithError.tsx";
import { AtomProps } from "@/uiKit/atoms/utils/AtomTypes.ts";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";

export type BasePageContentProps = PropsWithChildren<{}>;

export type PageContentProps = AtomProps<BasePageContentProps>;

export const PageContent: React.FC<PageContentProps> = ({ id, className, children, ...props }) => {
  const styles = useStyles(makeStyles);

  return (
    <div id={id} className={cx(styles.root, className)} {...props}>
      <SuspenseWithError errorFallback={HandledErrorCard} pendingFallback={CenteredLoader}>
        {children}
      </SuspenseWithError>
    </div>
  );
};

const makeStyles = () => ({
  root: css({
    display: "flex",
    flexDirection: "column",
    padding: "0 2vw 2vh 2vw",
  }),
});
